import { CreateMyAirdropWalletSelectionFormValues } from "./types-dto"

export const createMyAirdropWalletSelectionFormValuesInitialValue = (erc20AddressId?: string,
    maticAddressId?: string,
    solAddressId?: string): CreateMyAirdropWalletSelectionFormValues => {
    return {
        erc20AddressId: erc20AddressId || '',
        maticAddressId: maticAddressId || '',
        solAddressId: solAddressId || ''
    }
}